import { apiRequest } from "@nusrif/utils";
import { GetConfigsResponse } from "@nusrif/types";

// Configs service to fetch application configurations
export async function loadConfigs(): Promise<GetConfigsResponse> {
  return apiRequest<GetConfigsResponse>('/configs', {
    method: 'GET'
  });
}